import { addDriver, deletedDriver, getAllDriver, getDriverById, updateDriver } from "../../../helpers/backend_helper";
import { driverError, driverRequest, driverSuccess,getDriverByIdRequest,getDriverByIdSuccess,getDriverByIdError } from "./reducer";

export const fetchDriver = (page:number,count:number,keyword:string) => async (dispatch: any) => {
    dispatch(driverRequest());
    try {
      const response: any = await getAllDriver(page,count,keyword);
      if (response && response.isSuccess) {
        dispatch(driverSuccess(response.data));
        return response
      } else {
        dispatch(driverError("Failed to fetch Driver"));
        return null
      }
    } catch (error: any) {
      dispatch(driverError(error.message));
      return null
    }
  };


  export const addNewDriver = (userData: any) => async (dispatch: any) => {
    dispatch(driverRequest());
    try {
      const response: any = await addDriver(userData);
      if (response && response.data) {
        dispatch(driverSuccess(response.data));
        return response; 
      } else {
        dispatch(driverError("Failed to add user"));
        return response;
      }
    } catch (error: any) {
      dispatch(driverError(error.message));
      return null;
    }
  };
  
  export const editDriver = (updatedData: any) => async (dispatch: any) => {
    dispatch(driverRequest());
    try {
      const response: any = await updateDriver(updatedData);
      if (response && response.data) {
        dispatch(driverSuccess(response.data));
        return response;
      } else {
        dispatch(driverError("Failed to edit user"));
        return response;
      }
    } catch (error: any) {
      dispatch(driverError(error.message));
      return null;
    }
  };
 
  export const fetchDriverById = (userId: string) => async (dispatch: any) => {
    dispatch(getDriverByIdRequest());
    try {
      const response: any = await getDriverById(userId);  
  
      if (response && response.isSuccess) {
        dispatch(getDriverByIdSuccess(response.data)); 
        return response;
      } else {
        dispatch(getDriverByIdError("Failed to fetch user by ID"));
        return response; 
      }
    } catch (error: any) {
      dispatch(getDriverByIdError(error.message));  
      return null;
    }
  };  

  export const removeDriver = (id: string) => async (dispatch: any) => {
    dispatch(driverRequest());
    try {
      const response: any = await deletedDriver(id);  
  
      if (response && response.isSuccess) {
        dispatch(driverSuccess(response.data)); 
        return response;
      } else {
        dispatch(driverError("Failed to fetch user by ID"));
        return response; 
      }
    } catch (error: any) {
      dispatch(driverError(error.message));  
      return null;
    }
  };